// extracted by mini-css-extract-plugin
export default {"checkBox":"Checkbox_checkBox__MxJ3S"};